// Settings > Account and backup > Supporter: where the pass stands, the perk choices, and the way
// to the Supporter page (pick a pass, redeem a code, link Discord). Nothing here is needed to study.
import { getSession, authedFetch, onAccountChange } from "../../app/account.js";
import { refresh, statusLine } from "../../shared/supporter.js";
import { renderPrefs } from "../../supporter/prefs.js";

function openPage(url) {
	if (window.top && window !== window.top) window.top.postMessage({ type: "revault-open", url }, location.origin);
	else location.href = url;
}
function el(tag, cls, text) { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
function btn(label, onClick, cls) { const b = el("button", "rv-btn" + (cls ? " " + cls : ""), label); b.type = "button"; b.addEventListener("click", onClick); return b; }

export function supporterBlock() {
	const body = el("div", "rv-supporter-wrap");
	body.setAttribute("role", "group");
	const live = el("div", "rv-sr");
	live.setAttribute("aria-live", "polite");
	live.style.cssText = "position:absolute;width:1px;height:1px;overflow:hidden;clip-path:inset(50%)";
	const say = (t) => { live.textContent = ""; setTimeout(() => { live.textContent = t; }, 30); };

	let gen = 0;
	async function render() {
		const my = ++gen;
		body.textContent = "";
		const line = el("p", "rv-row-desc", "");
		line.hidden = true;
		const row = el("div", "rv-btnrow");
		row.append(
			btn("Open the Supporter page", () => openPage("/supporter"), "rv-btn-primary"),
			btn("Redeem a code", () => openPage("/supporter#redeem")),
			btn("Link Discord", () => openPage("/supporter#link")),
		);
		body.append(line, row, el("p", "rv-row-desc", "Have a gift code, or a code from /supporter link on Discord? Use Redeem a code or Link Discord."));
		if (!getSession()) return;
		const st = await refresh(authedFetch);
		if (my !== gen || !st || st.down) return;
		line.textContent = statusLine(st);
		line.hidden = false;
		const prefs = el("div", "");
		body.append(prefs, live);
		renderPrefs(prefs, st, async (patch) => {
			try {
				const r = await authedFetch("/account/supporter/prefs", { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(patch) });
				return r.ok;
			} catch (e) { void e; return false; }
		}, say);
	}
	render();
	onAccountChange(render);
	return body;
}
